module.exports = __webpack_public_path__ + "static/N2N2s-b23ebc7a7c66a73055c7cc2091e49f7a.jpg";